<template>
	<div>
		<!-- dialog -->
		<v-dialog v-model="dialog" max-width="600">
			<v-card>
				<v-card-title class="primary--text">
					<v-btn icon @click="dialog = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>

					<v-spacer/>
					<span class="me-8">
						{{ !vehicleId ? $t('VehiclesData.add-vehicle') : $t('VehiclesData.edit-vehicle')}}
					</span>
					<v-spacer/>
				</v-card-title>
				<v-card-text class="pb-0">
					<v-row>
						<!-- vehicle-no -->
						<v-col sm="4" cols="12">
							<v-text-field
								v-model="vehicleNo"
								:label="$t('inputs.vehicle-no')"
								dense
								hide-details
								outlined
							></v-text-field>
						</v-col>

						<!-- gps device number -->
						<v-col sm="4" cols="12" class="px-sm-0">
							<v-text-field
								v-model="gpsDeviceNumber"
								:label="$t('inputs.gps-device-number')"
								dense
								hide-details
								outlined
							></v-text-field>
						</v-col>

						<!-- passengers count -->
						<v-col sm="4" cols="12">
							<v-text-field
								v-model="passengersCount"
								:label="$t('inputs.passengers-count')"
								dense
								hide-details
								outlined
							></v-text-field>
						</v-col>

						<!-- username -->
						<v-col sm="6" cols="12">
							<v-text-field
								v-model="username"
								:label="$t('inputs.username')"
								dense
								hide-details
								outlined
							></v-text-field>
						</v-col>

						<!-- password -->
						<v-col sm="6" cols="12">
							<v-text-field
								v-model="password"
								:label="$t('inputs.password')"
								dense
								hide-details
								outlined
							></v-text-field>
						</v-col>

						<!-- driver -->
						<v-col sm="6" cols="12">
							<v-text-field
								v-model="driver"
								:label="$t('inputs.driver')"
								dense
								hide-details
								outlined
							></v-text-field>
						</v-col>

						<!-- driver-phone -->
						<v-col sm="6" cols="12">
							<v-text-field
								v-model="driverPhone"
								:label="$t('inputs.driver-phone')"
								dense
								hide-details
								outlined
							></v-text-field>
						</v-col>
						
						<!-- assistant -->
						<v-col sm="6" cols="12">
							<v-text-field
								v-model="assistant"
								:label="$t('inputs.assistant')"
								dense
								hide-details
								outlined
							></v-text-field>
						</v-col>
						
						<!-- assistant-phone -->
						<v-col sm="6" cols="12">
							<v-text-field
								v-model="assistantPhone"
								:label="$t('inputs.assistant-phone')"
								dense
								hide-details
								outlined
							></v-text-field>
						</v-col>
						
						<!-- regions -->
						<v-col cols="12">
							<v-text-field
								v-model="regions"
								:label="$t('inputs.regions')"
								dense
								hide-details
								outlined
							></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer/>
					<v-btn
						color="green white--text"
						:loading="submitLoading"
						@click="''"
					>
						{{$t('save')}}
					</v-btn>
					<v-btn @click="dialog = false">
						{{$t('cancel')}}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- restartDialog -->
		<v-dialog v-model="restartDialog" max-width="380">
			<v-card>
				<v-card-title class="orange--text">
					<v-btn icon @click="restartDialog = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>

					<v-spacer/>
					<span class="me-8">
						{{$t('VehiclesData.confirm-reconnecting-gps')}}
					</span>
					<v-spacer/>
				</v-card-title>
				<v-card-text class="py-3 text-body-1 grey--text text--darken-2">
					{{$t('VehiclesData.confirm-reconnecting-message')}}
				</v-card-text>
				<v-card-actions>
					<v-spacer/>
					<v-btn
						color="orange white--text"
						:loading="restartGPSLoading"
						@click="restartGPS"
					>
						{{$t('confirm')}}
					</v-btn>
					<v-btn @click="restartDialog = false">
						{{$t('cancel')}}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- filter -->
		<v-form @submit.prevent="">
			<v-row class="mb-0 mx-0">
				<template v-if="userAddEditMode">
					<v-col lg="3" md="4" sm="6" cols="12" class="px-1">
						<v-autocomplete
							:label="$t('inputs.vehicle-number-driver-assistant')"
							:items="['11215-عبد الفتاح', '1115-عبد الهادي',]"
							dense
							outlined
							clearable
							hide-details
							:loading="loading"
						></v-autocomplete>
					</v-col>
					
					<!-- search -->
					<v-col cols="auto" class="px-1">
						<v-btn
							color="orange white--text"
							type="submit"
							:loading="loading"
						>
							{{$t('search')}}
						</v-btn>
					</v-col>
					
					<v-spacer/>
					
					<!-- add vehicle -->
					<v-col cols="auto" class="px-1">
						<v-btn
							color="green white--text"
							class="px-3"
							@click="dialog = true"
						>
							<v-icon class="me-1">mdi-plus-circle-outline</v-icon>
							{{$t('add')}}
						</v-btn>
					</v-col>
				</template>

				<!-- restart gps -->
				<v-col md="auto" sm="4" cols="auto" class="px-1">
					<v-btn
						color="orange white--text"
						class="px-3"
						@click="restartDialog = true"
					>
						<v-icon class="me-1">mdi-wifi-refresh</v-icon>
						{{$t('VehiclesData.reconnect-gps')}}
					</v-btn>
				</v-col>
			</v-row>
		</v-form>

		<!-- table -->
		<v-data-table
			:headers="headers"
			:items="!loading ? vehicles : []"
			:loading="loading"
			dense
			disable-sort
			:items-per-page="20"
			:footer-props="{
				'items-per-page-options': [10, 20, 40, -1]
			}"
			fixed-header
			:height="$vuetify.breakpoint.height - 191"
			class="elevation-2"
		>
			<template v-slot:item.actions="{ item }">
				<v-tooltip v-if="userAddEditMode" top>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							depressed
							height="30"
							width="30"
							min-width="30"
							class="my-1 me-2"
							color="purple lighten-4 primary--text"
							v-on="on"
							v-bind="attrs"
							@click="vehicleId = item.Id; dialog = true"
						>
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
					</template>

					{{$t('edit')}}
				</v-tooltip>

				<!-- vehicle path -->
				<v-tooltip top>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							depressed
							height="30"
							width="30"
							min-width="30"
							class="my-1"
							color="blue lighten-4 primary--text"
							v-on="on"
							v-bind="attrs"
							@click="$router.push({ name: 'map-management', query: { vehicleId: item.Id } })"
						>
							<v-icon>mdi-map-marker-path</v-icon>
						</v-btn>
					</template>

					{{$t('tooltips.update-path')}}
				</v-tooltip>
			</template>
		</v-data-table>
	</div>
</template>

<script>
import { userAddEditMode } from '@/configs/general.configs';
import { mapState } from 'vuex';

export default {
	name: 'VehiclesData',

	data: () => ({
		// helpers
		loading: false,
		restartGPSLoading: false,
		submitLoading: false,
		
		dialog: false,
		restartDialog: false,

		vehicleId: null,
		
		// configs
		userAddEditMode,

		// data
		vehicleNo: null,
		driver: null,
		driverPhone: null,
		assistant: null,
		assistantPhone: null,
		username: null,
		password: null,
		gpsDeviceNumber: null,
		passengersCount: null,
		regions: null,
	}),

	watch: {
		dialog(newVal) {
			if (newVal) {
				// 
			}
		}
	},

	computed: {
		...mapState({
			vehicles: state => state.vehicles.vehicles,
		}),

		headers() {
			const headers = [
				{
					text: this.$t('headers.vehicle-no'),
					value: 'BusNo',
					width: 90
				},
				{
					text: this.$t('headers.driver'),
					value: 'DriverName',
				},
				{
					text: this.$t('headers.driver-phone'),
					value: 'DrvierNumber',
				},
				{
					text: this.$t('headers.assistant'),
					value: 'AssistantName',
				},
				{
					text: this.$t('headers.assistant-phone'),
					value: 'AssistantNumber',
				},
				{
					text: this.$t('headers.passengers-count'),
					value: 'NumberOfPassengers',
				},
				{
					text: this.$t('headers.regions'),
					value: 'Area',
					width: 350
				},
				{
					text: '',
					value: 'actions',
					width: 105
				},
			];

			for (let i = 0; i < headers.length; i++) {
				headers[i].class = headers.class ? headers.class + ' pe-0' : 'pe-0';
				headers[i].cellClass = headers.cellClass ? headers.cellClass + ' pe-0' : 'pe-0';
			}

			return headers
		}
	},

	methods: {
		restartGPS() {
			this.restartGPSLoading = true;
			this.$store.dispatch('vehicles/restartGPSdata').then(() => {
				this.$eventBus.$emit('show-snackbar', 'info', this.$t('messages.reconnecting-gps-succeeded'));
				this.restartDialog = false;
			}).finally(() => {
				this.restartGPSLoading = false;
			})
		}
	},

	created() {
		if (!this.vehicles.length) {
			this.loading = true;
			this.$store.dispatch('vehicles/fetchAll').finally(() => {
				this.loading = false;
			})
		}
	}
}
</script>

<style>

</style>